<h1 mat-dialog-title>Gerar boletos em demanda</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="max-width: '500';">

  <div *ngIf="!bGerandoBoleto && !bBoletosGerados">
    <div class="row">
      <div class="col-sm">
        <div class="row mt-4">
          <div class="col-sm" style="max-width: 400px;">
            <strong *ngIf="pedidosGerarBoleto.length > 0">Pedidos a gerar boleto automaticamente:</strong>
            {{sPedidosGerarBoleto}}
            <br>
            <mat-hint align="start" style="font-size: smaller;" *ngIf="pedidosGerarBoleto.length > 0">
              <strong>* A data de vencimento será gerada a partir da data da compra somando 10 ou 15 dias (escolhido
                pelo
                cliente);</strong>
            </mat-hint>
          </div>
        </div>
      </div>
    </div>
    <br>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
      <button mat-flat-button color="warn" (click)="cancelar()">
        <mat-icon>clear</mat-icon> Cancelar
      </button>
      <button mat-flat-button color="primary" (click)="confirmarGerarBoletos()" *ngIf="pedidosGerarBoleto.length > 0">
        <mat-icon>check</mat-icon> Gerar boletos
      </button>
    </section>
  </div>

  <div *ngIf="bGerandoBoleto && !bBoletosGerados">
    <div class="row">
      <div class="col-sm">
        <mat-progress-bar mode="determinate" [value]="contProgresso"></mat-progress-bar>
        <div style="text-align: center;">{{this.contProgresso}}%</div>
      </div>
    </div>
  </div>

  <div *ngIf="bBoletosGerados">

    <div class="row mt-4" *ngIf="!bFalhaGerarBoleto">
      <div class="col-sm">
        <h1 style="color: gray">Boletos gerados com sucesso!</h1>
      </div>
    </div>

    <div *ngIf="bFalhaGerarBoleto">
      <div class="row mt-4">
        <div class="col-sm">
          Falha ao geras {{statusGerarBoleto.length}} boletos:<br>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-auto" *ngFor="let statusBoleto of statusGerarBoleto">
          Pedido: {{statusBoleto.Pedido}},
          Erro: {{statusBoleto.Erro}}
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
      <button mat-flat-button color="warn" (click)="cancelar()">
        <mat-icon>clear</mat-icon> Cancelar
      </button>
      <button mat-flat-button color="primary" (click)="imprimirBoletos()" *ngIf="pedidosGerarBoleto.length > 0">
        <mat-icon>print</mat-icon> Imprimir boletos
      </button>
    </section>
  </div>

</div>
